import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=52ce0c10&scoped=true&"
import script from "./Attributes.vue?vue&type=script&lang=ts&"
export * from "./Attributes.vue?vue&type=script&lang=ts&"
import style0 from "./Attributes.vue?vue&type=style&index=0&id=52ce0c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce0c10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VImg,VProgressCircular})
